module.exports = __webpack_public_path__ + "img/button_press down_03.99bb57b6.png";